import { render, staticRenderFns } from "./styleSlider.vue?vue&type=template&id=445c3ac6&scoped=true&"
import script from "./styleSlider.ts?vue&type=script&lang=js&"
export * from "./styleSlider.ts?vue&type=script&lang=js&"
import style0 from "./styleSlider.vue?vue&type=style&index=0&id=445c3ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445c3ac6",
  null
  
)

export default component.exports